// experienceTemplates.js
// ─────────────────────────────────────────────────────────────
// Designation likhte hi Experience Points auto-fill karne ke liye.
//
// Naya role add karna ho to bas is array me ek object push kar do —
// UI khud utha lega, DocumentsPanel.jsx chhune ki zarurat nahi.
//
//   label   → chip par jo dikhega
//   aliases → designation field me jo bhi likha jaye, match ke liye
//   points  → letter ke bullet points (har line = ek bullet)
// ─────────────────────────────────────────────────────────────

export const EXPERIENCE_TEMPLATES = [
  {
    key: "data-analyst",
    label: "Data Analyst",
    aliases: ["data analyst", "data analytics", "data analysis", "analytics executive"],
    points: [
      "Processed and analyzed data using Python libraries like NumPy and Pandas to ensure accuracy and efficiency in data handling.",
      "Utilized statistical techniques and tools like Excel and SQL for data analysis and validation.",
      "Designed interactive dashboards and reports in Power BI, Tableau, and Excel, providing actionable insights.",
      "Monitored and identified trends, patterns, and anomalies in datasets to support business decision-making processes.",
    ],
  },
  {
    key: "mis",
    label: "MIS Executive",
    aliases: ["mis", "mis executive", "mis analyst", "mis officer"],
    points: [
      "Utilized tools like Excel and SQL to perform detailed data analysis and generate reports for business review.",
      "Created interactive and visually appealing dashboards in Power BI, Tableau, and Excel to support data-driven decision-making.",
      "Monitored and maintained MIS systems to ensure timely and accurate reporting across departments.",
      "Identified data trends and provided actionable insights to enhance operational efficiency and support strategic planning.",
    ],
  },
  {
    key: "business-analyst",
    label: "Business Analyst",
    aliases: ["ba", "business analyst", "business analysis"],
    points: [
      "Participated in requirement elicitation sessions and converted business needs into detailed functional and technical specifications.",
      "Created process maps, data flow diagrams (DFDs), and user journey flows to support system design and engineering teams.",
      "Assisted in preparing BRDs, FRDs, user stories, acceptance criteria, and maintaining structured documentation in tools like JIRA/Confluence.",
      "Performed SQL-based analysis and data checks to validate use cases, identify anomalies, and support feature decisions.",
    ],
  },
  {
    key: "data-scientist",
    label: "Data Scientist",
    aliases: ["ds", "data scientist", "data science", "ml engineer", "machine learning engineer"],
    points: [
      "Utilize Python libraries such as NumPy, Pandas, Scikit-learn, Matplotlib, and Seaborn for efficient data manipulation, analysis, and visualization.",
      "Apply machine learning algorithms (regression, classification, clustering, etc.) to build predictive models and extract actionable insights from structured and unstructured data.",
      "Perform data cleaning, preprocessing, and feature engineering to prepare data for analytical and modeling tasks.",
      "Work with large datasets using tools like SQL, BigQuery, and cloud platforms (AWS, GCP, Azure) to retrieve, store, and process data efficiently.",
    ],
  },
  {
    key: "java-full-stack",
    label: "Java Full Stack Developer",
    aliases: [
      "javafsd", "java fsd", "java full stack", "java full stack developer",
      "java fullstack", "java developer",
    ],
    points: [
      "Develop responsive and visually appealing user interfaces using HTML, CSS, and JavaScript, with expertise in front-end frameworks such as ReactJS and Angular.",
      "Ensure web applications are optimized for mobile and desktop platforms, focusing on building interactive web components.",
      "Design, develop, and maintain server-side logic using Java (Java 8 & 17+), Spring Boot, and related frameworks like Hibernate.",
      "Integrate databases such as MySQL, PostgreSQL, or MongoDB and manage data storage solutions efficiently.",
    ],
  },
  {
    key: "full-stack",
    label: "Full Stack Developer",
    aliases: [
      "fsd", "full stack", "fullstack", "full stack developer",
      "mern", "mern stack developer", "software developer", "web developer",
    ],
    points: [
      "Develop responsive and visually appealing user interfaces using HTML, CSS, and JavaScript.",
      "Ensure web applications are optimized for mobile and desktop platforms.",
      "Design, develop, and maintain server-side logic using relevant programming languages such as Python, Node.js, or Ruby.",
      "Integrate databases and manage data storage solutions.",
      "Design and optimize database schemas.",
      "Share technical expertise and best practices with team members.",
    ],
  },
  {
    key: "automation-tester",
    label: "Automation Test Engineer",
    aliases: [
      "automation test engineer", "automation tester", "automation testing",
      "automation qa", "sdet", "test automation engineer",
    ],
    points: [
      "Work closely with developers, product managers, and business analysts to understand automation requirements and application workflows.",
      "Analyze requirement documents, user stories, and use cases to identify automation feasibility and test scenarios.",
      "Design, develop, and maintain automation test scripts using tools like Selenium, Cypress, TestNG, JUnit, or similar frameworks.",
      "Develop and maintain automation test frameworks (Data-Driven, Keyword-Driven, Hybrid).",
      "Execute automated test suites for functional, regression, smoke, and sanity testing across web and mobile applications.",
    ],
  },
  {
    key: "manual-tester",
    label: "Manual Tester",
    aliases: ["manual tester", "manual testing", "manual qa", "manual test engineer"],
    points: [
      "Work closely with developers, product managers, and business analysts to understand requirements and clarify functionality.",
      "Analyze requirement documents, user stories, and use cases to identify test scenarios.",
      "Design, write, and execute detailed manual test cases and test plans.",
      "Perform functional, regression, smoke, sanity, and exploratory testing on web and mobile applications.",
      "Identify, document, and track defects using bug-tracking tools (e.g., Jira).",
      "Validate fixes and perform re-testing to ensure issues are resolved correctly.",
    ],
  },
  {
    key: "software-tester",
    label: "Software Tester",
    aliases: ["software tester", "software testing", "test engineer", "tester"],
    points: [
      "Work closely with developers, product managers, and business analysts to understand project requirements and software functionality.",
      "Analyze requirement documents, user stories, and technical specifications to identify test scenarios and testing requirements.",
      "Design, develop, and execute test cases, test plans, and test scripts for web and mobile applications.",
      "Perform functional, regression, smoke, sanity, integration, and exploratory testing to ensure software quality and reliability.",
      "Identify, document, prioritize, and track defects using bug-tracking tools such as Jira.",
    ],
  },
  {
    key: "qa-tester",
    label: "QA Tester",
    aliases: ["qa tester", "qa", "qa engineer", "quality analyst", "qa analyst", "quality assurance"],
    points: [
      "Work closely with developers, product managers, and business analysts to understand business requirements and application workflows.",
      "Analyze requirement documents, user stories, and use cases to identify test scenarios and ensure complete test coverage.",
      "Prepare detailed test cases, test plans, and test scenarios based on functional specifications.",
      "Perform manual testing including functional, regression, smoke, sanity, integration, and system testing for web and mobile applications.",
      "Identify, document, and track defects using bug tracking tools, and coordinate with the development team for timely resolution.",
    ],
  },
];

// ── Helpers ──────────────────────────────────────────────

/** "QA  Tester!" → "qa tester" */
function normalize(text) {
  return String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

/** Template ka bullet text (textarea me jo jayega) */
export function templateText(tpl) {
  return tpl ? tpl.points.join("\n") : "";
}

/**
 * Designation se template dhoondho.
 * Lambe alias pehle check hote hain, isliye "java full stack" kabhi
 * plain "full stack" me nahi girega, aur "automation tester" kabhi
 * plain "tester" me nahi.
 */
export function matchTemplate(designation) {
  const text = normalize(designation);
  if (!text) return null;

  const pairs = [];
  EXPERIENCE_TEMPLATES.forEach((tpl) => {
    tpl.aliases.forEach((a) => pairs.push({ tpl, alias: normalize(a) }));
  });
  pairs.sort((a, b) => b.alias.length - a.alias.length);

  for (const { tpl, alias } of pairs) {
    // word-boundary match — "ba" kabhi "database" ke andar match nahi karega
    const re = new RegExp(`(^| )${alias.replace(/ /g, " ")}( |$)`);
    if (re.test(text)) return tpl;
  }
  return null;
}

/** Kya textarea ka text abhi bhi koi untouched template hai? */
export function isUntouchedTemplateText(text) {
  const t = String(text || "").trim();
  if (!t) return true; // khali bhi "untouched" hai
  return EXPERIENCE_TEMPLATES.some((tpl) => templateText(tpl).trim() === t);
}

export function templateByKey(key) {
  return EXPERIENCE_TEMPLATES.find((t) => t.key === key) || null;
}